/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Reveal_Title2Inputs */

const en_settings_reportingapikeys_reveal_title2 = /** @type {(inputs: Settings_Reportingapikeys_Reveal_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key generated`)
};

/**
* | output |
* | --- |
* | "API key generated" |
*
* @param {Settings_Reportingapikeys_Reveal_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_reveal_title2 = /** @type {((inputs?: Settings_Reportingapikeys_Reveal_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Reveal_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_reveal_title2(inputs)
});
export { settings_reportingapikeys_reveal_title2 as "settings_reportingApiKeys_reveal_title" }